import { BoxArrowUpRight } from "@styled-icons/bootstrap";
import { Col } from "components/primitives";
import { FC } from "react";
import styled from "styled-components";
import { openInNewTab } from "util/openInNewTap";

import { SegmentProps } from "./ToolbarContainer";
import { ToolbarHeaderButton } from "./ToolbarHeaderButton";
import { ToolbarSegmentHeader } from "./ToolbarSegmentHeader";

// Learning videos removed for first demo
export const SettingsToolbar: FC<SegmentProps> = ({ setCurrentSegment }) => {
  const REACT_APP_PARENT_ORIGIN =
    process.env.REACT_APP_PARENT_ORIGIN || "https://topteacher.com.au/";
  return (
    <>
      <ToolbarSegmentHeader header="Settings" onBack={() => setCurrentSegment("main")} />
      <TopButtonContainer>
        <ToolbarHeaderButton onClick={() => setCurrentSegment("backgrounds")}>
          Background
        </ToolbarHeaderButton>
        <ToolbarHeaderButton onClick={() => setCurrentSegment("fonts")}>Font</ToolbarHeaderButton>
        {false && (
          <ToolbarHeaderButton onClick={() => openInNewTab(REACT_APP_PARENT_ORIGIN)}>
            Learning Videos <BoxArrowUpRight height={"60%"} />
          </ToolbarHeaderButton>
        )}
        <ToolbarHeaderButton onClick={() => setCurrentSegment("sounds")}>
          Read Aloud
        </ToolbarHeaderButton>
      </TopButtonContainer>
    </>
  );
};

const TopButtonContainer = styled(Col)`
  width: 100%;
  gap: 10px;
`;
